import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grow flex flex-col overflow-x-hidden" }
const _hoisted_2 = { class: "bg-gray-50" }
const _hoisted_3 = { class: "py-24 lg:py-32" }
const _hoisted_4 = { class: "relative z-10 mx-auto max-w-7xl pl-4 pr-8 sm:px-6 lg:px-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl" }, "DNS lookup API", -1)
const _hoisted_6 = { class: "mt-6 max-w-3xl text-xl text-gray-500" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("section", {
  class: "grow relative bg-gray-50 pb-28",
  "aria-labelledby": "contact-heading"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "absolute top-0 right-0 z-0 -translate-y-16 translate-x-1/2 transform sm:translate-x-1/4 md:-translate-y-24 lg:-translate-y-72",
      width: "404",
      height: "384",
      fill: "none",
      viewBox: "0 0 404 384",
      "aria-hidden": "true"
    }, [
      /*#__PURE__*/_createElementVNode("defs", null, [
        /*#__PURE__*/_createElementVNode("pattern", {
          id: "64e643ad-2176-4f86-b3d7-f2c5da3b6a6d",
          x: "0",
          y: "0",
          width: "20",
          height: "20",
          patternUnits: "userSpaceOnUse"
        }, [
          /*#__PURE__*/_createElementVNode("rect", {
            x: "0",
            y: "0",
            width: "4",
            height: "4",
            class: "text-gray-200",
            fill: "currentColor"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("rect", {
        width: "404",
        height: "384",
        fill: "url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "relative bg-white shadow-xl" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-1 lg:grid-cols-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "relative overflow-hidden bg-gradient-to-b from-indigo-500 to-indigo-600 py-10 px-6 sm:px-10 xl:p-12" }, [
          /*#__PURE__*/_createElementVNode("div", {
            class: "pointer-events-none absolute inset-0 sm:hidden",
            "aria-hidden": "true"
          }, [
            /*#__PURE__*/_createElementVNode("svg", {
              class: "absolute inset-0 h-full w-full",
              width: "343",
              height: "388",
              viewBox: "0 0 343 388",
              fill: "none",
              preserveAspectRatio: "xMidYMid slice",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              /*#__PURE__*/_createElementVNode("path", {
                d: "M-99 461.107L608.107-246l707.103 707.107-707.103 707.103L-99 461.107z",
                fill: "url(#linear1)",
                "fill-opacity": ".1"
              }),
              /*#__PURE__*/_createElementVNode("defs", null, [
                /*#__PURE__*/_createElementVNode("linearGradient", {
                  id: "linear1",
                  x1: "254.553",
                  y1: "107.554",
                  x2: "961.66",
                  y2: "814.66",
                  gradientUnits: "userSpaceOnUse"
                }, [
                  /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#fff" }),
                  /*#__PURE__*/_createElementVNode("stop", {
                    offset: "1",
                    "stop-color": "#fff",
                    "stop-opacity": "0"
                  })
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", {
            class: "pointer-events-none absolute top-0 right-0 bottom-0 hidden w-1/2 sm:block lg:hidden",
            "aria-hidden": "true"
          }, [
            /*#__PURE__*/_createElementVNode("svg", {
              class: "absolute inset-0 h-full w-full",
              width: "359",
              height: "339",
              viewBox: "0 0 359 339",
              fill: "none",
              preserveAspectRatio: "xMidYMid slice",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              /*#__PURE__*/_createElementVNode("path", {
                d: "M-161 382.107L546.107-325l707.103 707.107-707.103 707.103L-161 382.107z",
                fill: "url(#linear2)",
                "fill-opacity": ".1"
              }),
              /*#__PURE__*/_createElementVNode("defs", null, [
                /*#__PURE__*/_createElementVNode("linearGradient", {
                  id: "linear2",
                  x1: "192.553",
                  y1: "28.553",
                  x2: "899.66",
                  y2: "735.66",
                  gradientUnits: "userSpaceOnUse"
                }, [
                  /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#fff" }),
                  /*#__PURE__*/_createElementVNode("stop", {
                    offset: "1",
                    "stop-color": "#fff",
                    "stop-opacity": "0"
                  })
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", {
            class: "pointer-events-none absolute top-0 right-0 bottom-0 hidden w-1/2 lg:block",
            "aria-hidden": "true"
          }, [
            /*#__PURE__*/_createElementVNode("svg", {
              class: "absolute inset-0 h-full w-full",
              width: "160",
              height: "678",
              viewBox: "0 0 160 678",
              fill: "none",
              preserveAspectRatio: "xMidYMid slice",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              /*#__PURE__*/_createElementVNode("path", {
                d: "M-161 679.107L546.107-28l707.103 707.107-707.103 707.103L-161 679.107z",
                fill: "url(#linear3)",
                "fill-opacity": ".1"
              }),
              /*#__PURE__*/_createElementVNode("defs", null, [
                /*#__PURE__*/_createElementVNode("linearGradient", {
                  id: "linear3",
                  x1: "192.553",
                  y1: "325.553",
                  x2: "899.66",
                  y2: "1032.66",
                  gradientUnits: "userSpaceOnUse"
                }, [
                  /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#fff" }),
                  /*#__PURE__*/_createElementVNode("stop", {
                    offset: "1",
                    "stop-color": "#fff",
                    "stop-opacity": "0"
                  })
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("h2", { class: "text-lg text-white font-medium mb-3" }, "Our API supports"),
          /*#__PURE__*/_createElementVNode("ul", { class: "prose text-white list-disc list-inside" }, [
            /*#__PURE__*/_createElementVNode("li", null, "All DNS record types"),
            /*#__PURE__*/_createElementVNode("li", null, "Authoritative, uncached responses"),
            /*#__PURE__*/_createElementVNode("li", null, "Sampled recursive DNS server caches"),
            /*#__PURE__*/_createElementVNode("li", null, "Single query and batch end points"),
            /*#__PURE__*/_createElementVNode("li", null, "≥99.95% uptime"),
            /*#__PURE__*/_createElementVNode("li", null, "500 free queries per month"),
            /*#__PURE__*/_createElementVNode("li", null, "24h email support")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "py-10 px-6 sm:px-10 lg:col-span-2 xl:p-12" }, [
          /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium text-gray-900" }, "Join the waitlist"),
          /*#__PURE__*/_createElementVNode("form", {
            class: "mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8",
            method: "POST",
            action: "https://93a33901.sibforms.com/serve/MUIEANK2pNAvSHWpq9gDkB1cp3nnrajHYBPctlFLwE5dmrxBgxdK4D9BQkfueknFt4kZZRSQ97EgebTgHG9Ar8taM7niUDHLxiEDUZK-aXV71Vm0Nm27gOu5hfPM2jDUCkaHSgC98Y5HdTLg2y06s1kQPj0XMvhRmZIc0kNpLMiLyl6DKmx1E9H4FDShjx1csb1CeahpbvioutNr"
          }, [
            /*#__PURE__*/_createElementVNode("div", null, [
              /*#__PURE__*/_createElementVNode("label", {
                for: "first-name",
                class: "block text-sm font-medium text-gray-900"
              }, "First name"),
              /*#__PURE__*/_createElementVNode("div", { class: "mt-1" }, [
                /*#__PURE__*/_createElementVNode("input", {
                  maxlength: "200",
                  type: "text",
                  id: "FIRSTNAME",
                  name: "FIRSTNAME",
                  "data-required": "true",
                  required: "",
                  autocomplete: "given-name",
                  class: "block w-full rounded-md border border-gray-300 py-3 px-4 text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", null, [
              /*#__PURE__*/_createElementVNode("label", {
                for: "last-name",
                class: "block text-sm font-medium text-gray-900"
              }, "Last name"),
              /*#__PURE__*/_createElementVNode("div", { class: "mt-1" }, [
                /*#__PURE__*/_createElementVNode("input", {
                  maxlength: "200",
                  type: "text",
                  id: "LASTNAME",
                  name: "LASTNAME",
                  "data-required": "true",
                  required: "",
                  autocomplete: "family-name",
                  class: "block w-full rounded-md border border-gray-300 py-3 px-4 text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-2" }, [
              /*#__PURE__*/_createElementVNode("label", {
                for: "EMAIL",
                class: "block text-sm font-medium text-gray-900"
              }, "Business email"),
              /*#__PURE__*/_createElementVNode("div", { class: "mt-1" }, [
                /*#__PURE__*/_createElementVNode("input", {
                  type: "text",
                  id: "EMAIL",
                  name: "EMAIL",
                  autocomplete: "off",
                  "data-required": "true",
                  required: "",
                  class: "block w-full rounded-md border border-gray-300 py-3 px-4 text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-2 sm:flex sm:justify-end" }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "submit",
                class: "mt-2 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-500 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
              }, "Request access")
            ]),
            /*#__PURE__*/_createElementVNode("label", {
              class: "hidden",
              for: "email_address_check",
              "data-required": "*"
            }, "Email address check"),
            /*#__PURE__*/_createElementVNode("input", {
              type: "text",
              name: "email_address_check",
              value: "",
              class: "d-none",
              id: "email_address_check"
            }),
            /*#__PURE__*/_createElementVNode("input", {
              type: "hidden",
              name: "locale",
              value: "en"
            }),
            /*#__PURE__*/_createElementVNode("input", {
              type: "hidden",
              name: "html_type",
              value: "simple"
            })
          ])
        ])
      ])
    ])
  ])
], -1)

import MetaTags from '@/components/MetaTags.vue';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ApiView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "DNS lookup API",
        description: "Fetch DNS records with the NsLookup DNS lookup API. It will always return fresh data, without caching anything on our end.",
        url: "https://www.nslookup.io/dns-lookup-api/"
      })
    ])),
    _createVNode(HeaderComponent),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, [
              _createTextVNode("Our "),
              _createVNode(_component_router_link, {
                to: "/",
                title: "DNS lookup"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("DNS lookup")
                ]),
                _: 1
              }),
              _createTextVNode(" API gives developers a reliable and fast way to query DNS records.")
            ])
          ])
        ])
      ]),
      _hoisted_7
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})